import { render, staticRenderFns } from "./avgMessagesPerSession.vue?vue&type=template&id=0ec1b2df&scoped=true&"
import script from "./avgMessagesPerSession.vue?vue&type=script&lang=js&"
export * from "./avgMessagesPerSession.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/bs-helpers.css?vue&type=style&index=0&id=0ec1b2df&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1b2df",
  null
  
)

export default component.exports